export default __webpack_public_path__ + "static/media/speedoc.de77f05a.png";